import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { ProduitComponent } from '../../../../pages/produit/produit.component';
import { Produit } from '../../model/produit';
import { plainToClass } from 'class-transformer';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { isDefined } from '@angular/compiler/src/util';
import { Plantarifaire } from '../../model/plantarifaire';



@Injectable()
export class PlanTarifaireService {

  plantarifaires: Plantarifaire[];

  iSconnecting: boolean = false;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              ) { }

  getPlantarifaire() {
    this.iSconnecting = true;
    return new Promise<Plantarifaire[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_PLANTARIFAIRE(),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: Plantarifaire[]) => {
            const plans = plainToClass(Plantarifaire, data);
            this.plantarifaires = plans;
            resolve(plans);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
          });
    });
  }


  savePlantarifaire(plan: Plantarifaire) {

    this.iSconnecting = true;

    const body = {

      designation: plan.designation,
      tarifs: plan.tarifs,

    };


    if (plan.id !== 0) {

      this.iSconnecting = true;

      return new Promise<Plantarifaire>(resolve => {
        this.http.put(this.apiEndpoints.GET_URL_PUT_PLANTARIFAIRE(plan.id), body,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Plantarifaire) => {

              this.getPlantarifaire().then( () => {
                resolve(data);
                this.iSconnecting = false;
              });


            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }else {

      return new Promise<Plantarifaire>(resolve => {
        this.http.post(this.apiEndpoints.GET_URL_POST_PLANTARIFAIRE, body,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Plantarifaire) => {
              this.getPlantarifaire().then( () => {
                resolve(data);
                this.iSconnecting = false;
              });
            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });

    }



  }

  deletePlantarifaire(plan: Plantarifaire) {
    this.iSconnecting = true;
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.GET_URL_DELETE_PLANTARIFAIRE(plan.id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {

            this.getPlantarifaire().then( () => {
              resolve(data);
              this.iSconnecting = false;
            });

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
          });
    });


  }



}
